/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LocationChooser/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function LocationChooser({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/AddAction/AddDialog/Content/OrganizationChooser/Content/LocationChooser"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let selectedOrganizationLevelValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'organization_level',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(selectedOrganizationLevelValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}